<template>
	<AppSchemaFormWithValidation
		@submit="formSubmit"
		:schema="schema"
		:modelValue="modelValue"
		@update:modelValue="updateData"
		@plachchanged="placechanged"
	>
		<template #afterForm>
			<slot />
		</template>
	</AppSchemaFormWithValidation>
</template>

<script>
	import AppSchemaFormWithValidation from '@/components/app/AppSchemaFormWithValidation';

	export default {
		props: ['schema', 'modelValue', 'placechanged'],
		emits: ['submit', 'validation', 'update:modelValue'],
		components: {
			AppSchemaFormWithValidation,
		},
		setup(props, { emit }) {
			const formSubmit = () => {
				emit('submit');
			};

			const updateData = (data) => {
				emit('update:modelValue', data);
			};

			return {
				formSubmit,
				updateData,
			};
		},
	};
</script>
